export const setStyleFonts = () => {

	const brands = [
		{name: 'lrp', light: 'LocatorWeb-Light', regular: 'LocatorWeb-Regular', bold: 'LocatorWeb-Bold'},
		{name: 'vichy', light: 'FuturaPT-Light', regular: 'FuturaPT-Book', bold: 'FuturaPT-Bold'},
		{name: 'sanoflore', light: 'GillSans-Light', regular: 'GillSans-Regular', bold: 'GillSans-Bold'},
		{name: 'cerave', light: 'DinPro-Light', regular: 'DinPro-Regular', bold: 'DinPro-Bold'},
		{name: 'skinc', light: 'FuturaBT-Light', regular: 'FuturaBT-Book', bold: 'FuturaBT-Medium'},
		{name: 'biotherm', light: 'FuturaBT-Light', regular: 'FuturaBT-Book', bold: 'FuturaBT-Medium'},
		{name: 'sciencemd', light: 'LocatorWeb-Light', regular: 'LocatorWeb-Regular', bold: 'LocatorWeb-Bold'},
		{name: 'derm-expertise', light: 'Montserrat-Light', regular: 'Montserrat-Regular', bold: 'Montserrat-Bold'},
		{name: 'comptoir-dermato', light: 'Montserrat-Light', regular: 'Montserrat-Regular', bold: 'Montserrat-Bold'},
	];

	brands.forEach(brand => {
		const styleFonts = document.createElement('style');
		const name = brand.name;
		const light = brand.light;
		const regular = brand.regular;
		const bold = brand.bold;

		const styleFontsContent = [
			// section_wide-carousel
			".section_wide-carousel .obj_carousel .ctn_banner.var_"+ name +" .ctn_text h2,",
			".section_wide-carousel .obj_carousel .ctn_banner.var_"+ name +" .ctn_text h3,",
			".section_wide-carousel .obj_carousel .ctn_banner.var_"+ name +" .ctn_text p{",
			"	font-family:"+ light +";",
			"	}",
			".section_wide-carousel .obj_carousel .ctn_banner.var_"+ name +" .ctn_text h2 strong,",
			".section_wide-carousel .obj_carousel .ctn_banner.var_"+ name +" .ctn_text h4,",
			".section_wide-carousel .obj_carousel .ctn_banner.var_"+ name +" .ctn_text p strong{",
			"	font-family:"+ bold +";",
			"	}",
			// obj_push-custom
			".var_"+ name +" .obj_push-custom.var_full .ctn_text h3,",
			".var_"+ name +" .obj_push-custom.var_full .ctn_text h4,",
			".var_"+ name +" .obj_push-custom.var_full .ctn_text p{",
			"	font-family:"+ light +";",
			"	}",
			".var_"+ name +" .obj_push-custom.var_thumb h2,",
			".var_"+ name +" .obj_push-custom.var_full .ctn_text h2,",
			".var_"+ name +" .obj_push-custom.var_full .ctn_text p strong{",
			"	font-family:"+ bold +";",
			"	}",
			// obj_push-article
			".var_"+ name +" .obj_push-article .ctn_text h2{",
			"	font-family:"+ bold +";",
			"	}",
			// section_push-contact
			".var_"+ name +" .section_push-contact .ctn_text h2{",
			"	font-family:"+ bold +";",
			"	}",
			// section_social-network
			".var_"+ name +" .section_social-network h2{",
			"	font-family:"+ light +";",
			"	}",
			// section_article
			".var_"+ name +" .section_article .ctn_article h1{",
			"	font-family:"+ bold +";",
			"	}",
			// section_article-carousel
			".var_"+ name +" .section_article-carousel .ctn_banner h3{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_article-carousel h2{",
			"	font-family:"+ light +";",
			"	}",
			// section_product-detail
			".var_"+ name +" .section_product-detail .ctn_top-detail h1{",
			"	font-family:"+ light +";",
			"	}",
			".var_"+ name +" .section_product-detail .ctn_top-detail h1 strong,",
			".var_"+ name +" .section_product-detail .ctn_top-detail h2,",
			".var_"+ name +" .section_product-detail .ctn_desc-product h3{",
			"	font-family:"+ bold +";",
			"	}",
			// section_product-carousel
			".var_"+ name +" .section_product-carousel h2{",
			"	font-family:"+ bold +";",
			"	}",
			// obj_push-product
			".var_"+ name +" .obj_push-product .t_title,",
			".var_"+ name +" .obj_push-product .t_title-routine{",
			"	font-family:"+ light +";",
			"	}",
			".var_"+ name +" .obj_push-product .t_title strong,",
			".var_"+ name +" .obj_push-product .t_title-routine::before{",
			"	font-family:"+ bold +";",
			"	}",
			// obj_title
			".var_"+ name +" .obj_title{",
			"	font-family:"+ bold +";",
			"	}",
			// section_page-liste
			".var_"+ name +" .section_page-liste .ctn_page-liste h3,",
			".var_"+ name +" .section_page-liste .ctn_row > h2 strong{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_page-liste .ctn_row > h2{",
			"	font-family:"+ light +";",
			"	}",
			// section_formation-dashboard
			".var_"+ name +" .section_formation-dashboard .ctn_formation-dashboard h2{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_formation-dashboard .ctn_formation-dashboard .t_status{",
			"	font-family:"+ bold +";",
			"	}",
			// section_header-ingredients
			".var_"+ name +" .section_header-ingredients .ctn_header-ingredients figure figcaption{",
			"	font-family:"+ regular +";",
			"	}",
			// section_liste-ingredients
			".var_"+ name +" .section_liste-ingredients .obj_liste-ingredients .ctn_text h2{",
			"	font-family:"+ bold +";",
			"	}",
			// section_detail-ingredients
			".var_"+ name +" .section_detail-ingredients h1,",
			".var_"+ name +" .section_detail-ingredients h2{",
			"	font-family:"+ bold +";",
			"	}",
			// obj_banner-product
			".var_"+ name +" .obj_banner-product .ctn_text h1,",
			".var_"+ name +" .obj_banner-product .ctn_text h2,",
			".var_"+ name +" .section_range-liste .ctn_range-liste > h3 strong{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_range-liste .ctn_range-liste > h3{",
			"	font-family:"+ light +";",
			"	}",
			// obj_banner-routine
			".var_"+ name +" .obj_banner-routine h1{",
			"	font-family:"+ regular +";",
			"	}",
			// section_page-liste
			".var_"+ name +" .section_mini_parcours .obj_formation_mini_parcours h3{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_page-liste .ctn_row > h2{",
			"	font-family:"+ light +";",
			"	}",
			// Formations page
			// obj_tabs_parcours_formation
			".var_"+ name +" .obj_tabs_parcours_formation .obj_tabs_list_tabs .obj_btn_tab .t_title{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_tabs_parcours_formation .obj_tabs_list_tabs .obj_btn_tab.is_active .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_tabs_parcours_formation .obj_tabs_list_content .obj_tabs_content .ctn_title .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_tabs_parcours_formation .obj_tabs_list_content .obj_tabs_content .ctn_title .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page
			// obj_list_pushs_thematique_formation
			".var_"+ name +" .obj_list_pushs_thematique_formation .ctn_title .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			// Formations page
			// obj_push_card-thematique
			".var_"+ name +" .obj_push_card-thematique .ctn_content_card .ctn_text_card .t_title{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_push_card-thematique .ctn_content_card .ctn_text_card .t_title strong{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_push_card-thematique .ctn_content_card .ctn_text_card .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// section_hero_formation
			".var_"+ name +" .section_hero_formation .ctn_text .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_hero_formation .ctn_text .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .section_hero_formation .ctn_text .t_subtitle{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .section_hero_formation .obj_back-page .bt_back-page{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// obj_dashboard_header_formation
			".var_"+ name +" .obj_dashboard_header_formation .obj_dashboard_infos .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_dashboard_header_formation .obj_dashboard_infos .t_tag span{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_dashboard_header_formation .obj_dashboard_infos .obj_progress-bar_formation .t_title{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_dashboard_header_formation .obj_dashboard_infos .obj_progress-bar_formation .t_title strong{",
			"	font-family:"+ bold +";",
			"	}",
			// Formations page marque
			// obj_mon_parcours_formation
			".var_"+ name +" .obj_mon_parcours_formation .ctn_title .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_mon_parcours_formation .ctn_title .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// obj_menu_aside_thematiques
			".var_"+ name +" .ctn_aside .obj_menu_aside_thematiques > .t_title,",
			".var_"+ name +" .ctn_aside .obj_favorite_aside_formation > .t_title,",
			".var_"+ name +" .ctn_aside .obj_products_related_aside > .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .ctn_aside .obj_menu_aside_thematiques .obj_menu_aside_list .menu_aside-item a{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .ctn_aside .obj_menu_aside_thematiques .obj_menu_aside_list .menu_aside-item.is_current a{",
			"	font-family:"+ bold +";",
			"	}",
			// obj_favorite_aside_formation
			".var_"+ name +" .ctn_aside .obj_favorite_aside_formation .obj_menu_aside_list .menu_aside-item .menu_aside_text .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .ctn_aside .obj_favorite_aside_formation .obj_menu_aside_list .menu_aside-item .menu_aside_text .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .ctn_aside .obj_favorite_aside_formation .obj_menu_aside_list .menu_aside-item .menu_aside_text .obj_nb-views{",
			"	font-family:"+ regular +";",
			"	}",
			// obj_products_related_aside
			".var_"+ name +" .ctn_aside .obj_products_related_aside .obj_menu_aside_list .menu_aside-item a{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// obj_push_card
			".var_"+ name +" .obj_push_card .ctn_media_card .obj_info-left_card{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_push_card .ctn_media_card .obj_info-right_card .obj_timer_card{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_push_card .ctn_content_card .ctn_text_card .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_push_card .ctn_content_card .ctn_text_card .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_push_card .ctn_footer_card .obj_nb-views_card span{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// obj_mes_formations_filtre
			".var_"+ name +" .obj_mes_formations_filtre .ctn_title .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_mes_formations_filtre .ctn_title .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// obj_direct_comptoir_dermato
			".var_"+ name +" .obj_direct_comptoir_dermato .ctn_title .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			// Formations page marque
			// obj_socials_formation_footer
			".var_"+ name +" .obj_socials_formation_footer .ctn_text .t_title{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_socials_formation_footer .ctn_text .t_title strong{",
			"	font-family:"+ bold +";",
			"	}",
			// section_hero_formation-carrousel
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero.var_"+ name +" .ctn_text .t_title,",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero.var_"+ name +" .ctn_text h3,",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero.var_"+ name +" .ctn_text .t_desc{",
			"	font-family:"+ light +";",
			"	}",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero .ctn_text .t_title strong,",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero .ctn_text .t_subtitle,",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero .ctn_text .t_ribbon,",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero .ctn_text .t_ribbon,",
			".var_"+ name +" .section_hero_formation-carrousel .obj_carousel .obj_section_hero .obj_cta{",
			"	font-family:"+ bold +";",
			"	}",
			// Formations page marque
			// obj_a_la_une_formation / obj_a_gagner_formation
			".var_"+ name +" .obj_a_la_une_formation > .ctn_title .t_title,",
			".var_"+ name +" .obj_a_gagner_formation > .ctn_title .t_title,",
			".var_"+ name +" .obj_a_gagner_formation > .ctn_title .t_desc,",
			".var_"+ name +" .obj_a_la_une_formation > .ctn_title .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_a_la_une_formation > .ctn_title .t_title strong,",
			".var_"+ name +" .obj_a_gagner_formation > .ctn_title .t_title strong{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_a_la_une_formation .item_a_la_une_formation .ctn_text .t_ribbon span{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_a_la_une_formation .item_a_la_une_formation .ctn_text .t_title,",
			".var_"+ name +" .obj_a_gagner_formation .item_a_gagner_formation .ctn_text .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_a_la_une_formation .item_a_la_une_formation .ctn_text .t_desc{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_a_la_une_formation .item_a_la_une_formation .ctn_text .obj_cta,",
			".var_"+ name +" .obj_a_gagner_formation .item_a_gagner_formation .ctn_text .obj_cta{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .section_home_carrousel_tabs_formation .obj_tabs_parcours_formation > .ctn_cta .obj_cta-txt{",
			"	font-family:"+ regular +";",
			"	}",
			// Formations page marque
			// obj_contact_question_formation
			".var_"+ name +" .obj_contact_question_formation .ctn_text .t_title,",
			".var_"+ name +" .obj_contact_question_formation .ctn_text .t_desc strong,",
			".var_"+ name +" .obj_contact_question_formation .ctn_text .ctn_cta .obj_cta{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_contact_question_formation .ctn_text .t_desc,",
			".var_"+ name +" .obj_contact_question_formation .ctn_text .t_mentions{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_push_comptoir_dermato_espace_formation .ctn_text .t_title{",
			"	font-family:"+ regular +";",
			"	}",
			".var_"+ name +" .obj_push_comptoir_dermato_espace_formation .ctn_text .t_title strong,",
			".var_"+ name +" .obj_push_comptoir_dermato_espace_formation .ctn_text .ctn_cta .obj_cta{",
			"	font-family:"+ bold +";",
			"	}",
			// Formations page marque
			// obj_navigation_header_formation
			".var_"+ name +" .section_hero_formation .obj_navigation_header_formation .ctn_nav > .ctn_title .t_title{",
			"	font-family:"+ bold +";",
			"	}",
			// Formations Comptoir Dermato
			// obj_direct_comptoir_dermato
			".var_"+ name +" .obj_direct_comptoir_dermato > .ctn_text > .t_title,",
			".var_"+ name +" .obj_direct_comptoir_dermato > .ctn_text > p strong{",
			"	font-family:"+ bold +";",
			"	}",
			".var_"+ name +" .obj_direct_comptoir_dermato > .ctn_text > p{",
			"	font-family:"+ regular +";",
			"	}"
		].join('\n');

		document.head.appendChild(styleFonts);
		styleFonts.setAttribute('type', 'text/css');
		styleFonts.append(styleFontsContent);
	});
}

export default setStyleFonts;